import { getAuth } from 'firebase/auth';
import { app } from '../firebase';

export { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
export const auth = getAuth(app);
